import { useContext } from 'react';

import { Context } from '../providers/ModalProvider';

const useModal = () => useContext(Context);

export default useModal;
